import { render, staticRenderFns } from "./RegisterCardSimple.vue?vue&type=template&id=1cab49cc&scoped=true&"
import script from "./RegisterCardSimple.vue?vue&type=script&lang=js&"
export * from "./RegisterCardSimple.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCardSimple.vue?vue&type=style&index=0&id=1cab49cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cab49cc",
  null
  
)

export default component.exports